<template>
  <v-sheet class="mx-auto" max-width="2000">
    <v-container>
      <v-row align="center" justify="start">
        <v-col cols="12">
          <v-card class="mx-auto" variant="plain" elevation="5" title="Not found">
            <v-card-text>
              <p>
                The requested page was not found. Please make another selection.
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>
